import { useEffect, useState } from 'react';
import { UnitConverter } from '../../helper/currency-helper';
import { StocksOnHandBySector } from '../../models/dashboard';

const TopProfitByIndustryCard = ({ data }: PropsType) => {
  const [maxAmount, setMaxAmount] = useState<number>(1);
  const [displayData, setDisplayData] = useState<StocksOnHandBySector[] | null>(
    null
  );
  useEffect(() => {
    if (!data) return;
    const dataToDisplay = data
      .sort((d1, d2) => d2.profit - d1.profit)
      .slice(0, 11);

    let max = 1;
    dataToDisplay.every((d) => (max = Math.max(Math.abs(d.profit), max)));
    setMaxAmount(max);
    setDisplayData(dataToDisplay);
  }, [data]);
  return (
    <div className="flex flex-col col-span-full sm:col-span-6 xl:col-span-4 bg-white shadow-lg rounded-sm border border-slate-200">
      <header className="px-5 py-4 border-b border-slate-100 ">
        <h2 className="font-semibold text-slate-800 ">Top Earning Industry</h2>
      </header>
      <div className="grow p-3">
        <div className="flex flex-col h-full">
          {/* Card content */}
          <div className="grow">
            <ul className="flex justify-between text-xs uppercase text-slate-400  font-semibold px-2 space-x-2">
              <li>Industry</li>
              <li>Earning</li>
            </ul>

            <ul className="space-y-1 text-sm text-slate-800 mt-3 mb-4">
              {displayData &&
                displayData.map((d) => {
                  return (
                    <li key={d.sector} className="relative px-2 py-1">
                      <div
                        className={`absolute inset-0 ${
                          d.profit >= 0 ? 'bg-indigo-100 ' : 'bg-red-100 '
                        }`}
                        aria-hidden="true"
                        style={{
                          width: `${(Math.abs(d.profit) / maxAmount) * 85}%`,
                        }}
                      ></div>
                      <div className="relative flex justify-between space-x-2">
                        <div>{d.sector}</div>
                        <div className="font-medium">
                          ${UnitConverter(d.profit)}
                        </div>
                      </div>
                    </li>
                  );
                })}
              {/* Item */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

type PropsType = {
  data: StocksOnHandBySector[];
};

export default TopProfitByIndustryCard;
